<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('contacts')">{{ __('Users') }}</inertia-link>
      <span class="text-indigo-400 font-medium">/</span> {{ __('Quick add user') }}
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="submit">
        <p class="px-8 pt-8 text-sm text-gray-600 -mb-2">
          <span class="text-red-600">*</span> {{ __('Required fields') }}.
          {{ __('Other fields are optional.') }}
        </p>
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.email" :error="form.errors.email" class="pr-6 pb-8 w-full lg:w-1/2" :label="`${__('Email')} *`" type="string" required autofocus autocapitalize="off" />
          <text-input v-model="form.first_name" :error="form.errors.first_name" class="pr-6 pb-8 w-full lg:w-1/2" :label="optionalLabel('First Name')" />
          <text-input v-model="form.last_name" :error="form.errors.last_name" class="pr-6 pb-8 w-full lg:w-1/2" :label="optionalLabel('Last Name')" />
          <text-input v-model="form.lang" :error="form.errors.lang" class="pr-6 pb-8 w-full lg:w-1/2" :label="optionalLabel('Language')" />
          <text-input v-model="form.password" :error="form.errors.password" class="pr-6 pb-8 w-full lg:w-1/2" type="password" autocomplete="new-password" :label="optionalLabel('Password')" />
          <text-input v-model="form.bakery_name" :error="form.errors.bakery_name" class="pr-6 pb-8 w-full lg:w-1/2" :label="optionalLabel('Bakery Name')" />
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">{{ __('Create') }} {{ __('User') }}</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  metaInfo: { title: 'Quick add user' },
  components: {
    LoadingButton,
    TextInput,
  },
  layout: Layout,
  data() {
    return {
      form: this.$inertia.form({
        email: '',
        first_name: '',
        last_name: '',
        lang: 'nl',
        password: '',
        bakery_name: '',
      }),
    }
  },
  methods: {
    optionalLabel(fieldKey) {
      return `${this.__(fieldKey)} (${this.__('Optional')})`
    },
    submit() {
      this.form.post(this.route('owner.quick-users.store'))
    },
  },
}
</script>
